// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* 

.ticket-detail-header {
    font-size: 18px;
    color: #333;
    margin-bottom: 10px;
    border-bottom: 2px solid #ddd;
    padding-bottom: 5px;
}

.ticket-detail-container {
    background-color: #fff;
    border: 1px solid #ddd;
    border-radius: 5px;
    padding: 15px;
    margin-bottom: 20px;
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
}

.ticket-detail-paragraph {
    margin: 10px 0;
    font-size: 14px;
    color: #555;
}

.ticket-detail-status {
    font-weight: bold;
    padding: 5px 10px;
    border-radius: 3px;
    font-size: 12px;
}

.ticket-detail-status-active {
    background-color: #dff0d8;
    color: #3c763d;
}

.ticket-detail-status-closed {
    background-color: #f2dede;
    color: #a94442;
}



.ticket-detail-body {
    font-family: Arial, sans-serif;
    margin: 20px auto;
    padding: 20px;
    background-color: #f9f9f9;
    border-radius: 8px;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}



.ticket-detail-paragraph {
    margin: 10px 0;
    font-size: 1em;
    line-height: 1.6;
    color: #555;
}

.ticket-detail-status {
    padding: 5px 10px;
    border-radius: 4px;
    font-size: 0.9em;
    color: #fff;
}

.ticket-detail-status-open {
    background-color: #007bff;
}

.ticket-detail-status-resolved {
    background-color: #28a745;
}

.ticket-detail-status-pending {
    background-color: #ffc107;
}

.ticket-detail-status-closed {
    background-color: #6c757d;
}

.ticket-detail-replies-list {
    list-style: none;
    padding: 0;
}

 




.ticket-reply-form {
    margin-top: 20px;
}

.ticket-reply-error {
    color: #dc3545;
    margin-bottom: 10px;
}

.ticket-reply-textarea {
    width: 100%;
    padding: 15px;
    border: 1px solid #ddd;
    border-radius: 6px;
    font-size: 1em;
    resize: vertical;
    box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.1);
    transition: border-color 0.2s ease;
}

.ticket-reply-textarea:focus {
    border-color: #007bff;
    outline: none;
}

.ticket-reply-button {
    margin-top: 10px;
    padding: 10px 20px;
    background-color: #007bff;
    color: white;
    border: none;
    border-radius: 4px;
    font-size: 1em;
    cursor: pointer;
    transition: background-color 0.2s ease;
}

.ticket-reply-button:hover {
    background-color: #0056b3;
}

.ticket-detail-loading {
    text-align: center;
    font-size: 1.2em;
    color: #555;
}
.ticket-closed-container {
    margin-top: 20px;
    text-align: center;
}
.ticket-closed-message {
    color: #ff0000;
    font-weight: bold;
}
.ticket-reopen-button {
    margin-top: 10px;
    padding: 10px 20px;
    font-size: 16px;
    color: #fff;
    background-color: #007bff;
    border: none;
    border-radius: 5px;
    cursor: pointer;
}
.ticket-reopen-button:hover {
    background-color: #0056b3;
}


.ticket-detail-replies-list {
    list-style-type: none;
    padding: 10px;
    margin: 0;
    display: flex;
    flex-direction: column;
    gap: 15px;
    max-width: 95%;
    margin: auto;
}

.ticket-detail-reply-item {
    max-width: 75%;
    padding: 15px 20px;
    font-size: 16px;
    position: relative;
    word-wrap: break-word;
    display: flex;
    flex-direction: column;
}

.ticket-reply-user {
    background-color: #32383f;  
    color: white;
    align-self: flex-end;
    border-bottom-left-radius: 10px;
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
}

.ticket-reply-admin {
    background-color: #a4b1d2;  
    color: black;
    align-self: flex-start;
    border-bottom-right-radius: 10px;
    border-top-right-radius: 10px;
    border-top-left-radius: 10px;

}

.ticket-detail-reply-item p {
    font-size: 18px;
    margin: 5px 0;
}

.ticket-detail-reply-item small {
    font-size: 14px;
    margin-top: 5px;
    opacity: 0.7;
    align-self: flex-end;
}

.ticket-reply-user::after,
.ticket-reply-admin::after {
    content: "";
    position: absolute;
    bottom: 0;
    width: 0;
    height: 0;
}

.ticket-reply-user::after {
    right: -10px;
    border-left: 10px solid #222324;
    border-top: 10px solid transparent;
}

.ticket-reply-admin::after {
    left: -10px;
    border-right: 10px solid #a4b1d2;
    border-top: 10px solid transparent;
}

@media (max-width: 768px) {
    .ticket-detail-reply-item {
        max-width: 90%;
        font-size: 14px;
    }

    .ticket-detail-reply-item p {
        font-size: 16px;
    }

    .ticket-detail-reply-item small {
        font-size: 12px;
    }
} */
.ticket-detail-body {
    font-family: Arial, sans-serif;
    margin: 20px auto;
    padding: 20px;
    background-color: #f9f9f9;
    border-radius: 8px;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}
.ticket-detail-body {
    margin-top: 20px;
  }
  
  .ticket-detail-container {
    background-color: #f9f9f9;
    padding: 20px;
    border: 1px solid #ddd;
    border-radius: 5px;
  }
  
  .ticket-detail-status {
    font-weight: bold;
  }
  
  .ticket-detail-status-open {
    color: green;
  }
  
  .ticket-detail-status-closed {
    color: red;
  }
  
  .ticket-reply-admin {
    background-color: #e9f7e9;
  }
  
  .ticket-reply-user {
    background-color: #f1f1f1;
  }
  
  .ticket-reply-form textarea {
    resize: none;
  }
  
  .ticket-reply-button {
    margin-top: 10px;
  }
  


  .ticket-detail-replies-list {
    list-style: none;
    padding: 0;
  }
  
  .ticket-detail-reply-item {
    background: #f9f9f9;
    border: 1px solid #ddd;
    border-radius: 5px;
    padding: 10px 15px;
    margin-bottom: 15px;
    position: relative;
  }
  
  .ticket-detail-reply-item.ticket-reply-admin {
    background-color: #e6f7ff;
  }
  
  .ticket-detail-reply-item.ticket-reply-user {
    background-color: #fdfdfd;
  }
  
  .ticket-detail-reply-item p {
    margin: 0 0 5px;
  }
  
  .ticket-detail-reply-item small {
    display: block;
    font-size: 12px;
    color: #555;
  }
  
  .ticket-reply-badge {
    position: absolute;
    top: -10px;
    left: -10px;
    background-color: #007bff;
    color: white;
    padding: 2px 8px;
    border-radius: 3px;
    font-size: 12px;
  }
  
  .ticket-detail-timestamp {
    text-align: right;
    font-size: 12px;
    color: #888;
  }
  
  .ticket-reply-star-section {
    text-align: right;
    margin-top: 5px;
  }
  
  .ticket-reply-star-section .stars {
    display: inline-block;
    color: #ffa500;
  }
  .body
  {min-height: 100px;}

  .ticket-reply-badge {
    margin-left: 8px;
    padding: 2px 8px;
    font-size: 12px;
    border-radius: 3px;
    color: white;
    font-weight: bold;
  }
  
  .admin-badge {
    background-color: #a6c8ff; /* Màu xanh dương nhạt cho Operator */
  }
  
  .user-badge {
    background-color: #32cd32; /* Màu xanh lá tươi cho Owner */
  }
  .ticket-reply-item {
    display: flex;
    flex-direction: column;
    max-width: 70%;
    padding: 10px;
    background-color: #e6f7ff;
    border-radius: 10px;
    margin-bottom: 10px;
    align-self: flex-end;
    position: relative;
}
.ticket-reply-content {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

  .ticket-reply-date {
    font-size: 12px;
    color: gray;
    margin-left: auto;
    text-align: right;
    display: block;
    /* display: flex; */
}

.ticket-detail-container {
    max-width: 600px;
    background-color: #f9f9f9;
    border-radius: 12px;
  }
  
  .card-title {
    font-size: 22px;
    font-weight: 600;
  }
  
  .ticket-detail-paragraph {
    font-size: 14px;
  }
  
  .badge {
    padding: 8px 12px;
    font-size: 12px;
    border-radius: 20px;
  }
  .ticket-detail-container {
    max-width: 600px;
    margin: 0 auto;
  }
  
  .ticket-detail-content div {
    border-bottom: 1px solid #ddd;
    padding: 8px 0;
  }
  
  .status-text {
    font-size: 1rem;
  }
  
/* customer button */
  .custom-btn {
    background-color: transparent;
    color: white;
    border: none;
    padding: 10px 20px;
    border-radius: 50px;
    font-weight: bold;
    cursor: pointer;
    transition: all 0.3s ease-in-out;
  }
  
  .custom-btn.btn-success {
    background-color: #28a745;
  }
  
  .custom-btn.btn-success:hover {
    background-color: #218838;
  }
  
  .custom-btn.btn-danger {
    background-color: #dc3545;
  }
  
  .custom-btn.btn-danger:hover {
    background-color: #c82333;
  }
  .ck-editor__editable_inline {
    min-height: 200px !important;
  }
  `, "",{"version":3,"sources":["webpack://./src/pages/Ticket/Ticket.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;GA0PG;AACH;IACI,8BAA8B;IAC9B,iBAAiB;IACjB,aAAa;IACb,yBAAyB;IACzB,kBAAkB;IAClB,wCAAwC;AAC5C;AACA;IACI,gBAAgB;EAClB;;EAEA;IACE,yBAAyB;IACzB,aAAa;IACb,sBAAsB;IACtB,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,gBAAgB;EAClB;;;;EAIA;IACE,gBAAgB;IAChB,UAAU;EACZ;;EAEA;IACE,mBAAmB;IACnB,sBAAsB;IACtB,kBAAkB;IAClB,kBAAkB;IAClB,mBAAmB;IACnB,kBAAkB;EACpB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,cAAc;IACd,eAAe;IACf,WAAW;EACb;;EAEA;IACE,kBAAkB;IAClB,UAAU;IACV,WAAW;IACX,yBAAyB;IACzB,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,iBAAiB;IACjB,eAAe;IACf,WAAW;EACb;;EAEA;IACE,iBAAiB;IACjB,eAAe;EACjB;;EAEA;IACE,qBAAqB;IACrB,cAAc;EAChB;EACA;GACC,iBAAiB,CAAC;;EAEnB;IACE,gBAAgB;IAChB,gBAAgB;IAChB,eAAe;IACf,kBAAkB;IAClB,YAAY;IACZ,iBAAiB;EACnB;;EAEA;IACE,yBAAyB,EAAE,qCAAqC;EAClE;;EAEA;IACE,yBAAyB,EAAE,+BAA+B;EAC5D;EACA;IACE,aAAa;IACb,sBAAsB;IACtB,cAAc;IACd,aAAa;IACb,yBAAyB;IACzB,mBAAmB;IACnB,mBAAmB;IACnB,oBAAoB;IACpB,kBAAkB;AACtB;AACA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;AACvB;;EAEE;IACE,eAAe;IACf,WAAW;IACX,iBAAiB;IACjB,iBAAiB;IACjB,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,yBAAyB;IACzB,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;IACjB,eAAe;IACf,mBAAmB;EACrB;EACA;IACE,gBAAgB;IAChB,cAAc;EAChB;;EAEA;IACE,6BAA6B;IAC7B,cAAc;EAChB;;EAEA;IACE,eAAe;EACjB;;AAEF,oBAAoB;EAClB;IACE,6BAA6B;IAC7B,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;IACnB,iBAAiB;IACjB,eAAe;IACf,gCAAgC;EAClC;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;EAC3B;EACA;IACE,4BAA4B;EAC9B","sourcesContent":["/* \n\n.ticket-detail-header {\n    font-size: 18px;\n    color: #333;\n    margin-bottom: 10px;\n    border-bottom: 2px solid #ddd;\n    padding-bottom: 5px;\n}\n\n.ticket-detail-container {\n    background-color: #fff;\n    border: 1px solid #ddd;\n    border-radius: 5px;\n    padding: 15px;\n    margin-bottom: 20px;\n    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);\n}\n\n.ticket-detail-paragraph {\n    margin: 10px 0;\n    font-size: 14px;\n    color: #555;\n}\n\n.ticket-detail-status {\n    font-weight: bold;\n    padding: 5px 10px;\n    border-radius: 3px;\n    font-size: 12px;\n}\n\n.ticket-detail-status-active {\n    background-color: #dff0d8;\n    color: #3c763d;\n}\n\n.ticket-detail-status-closed {\n    background-color: #f2dede;\n    color: #a94442;\n}\n\n\n\n.ticket-detail-body {\n    font-family: Arial, sans-serif;\n    margin: 20px auto;\n    padding: 20px;\n    background-color: #f9f9f9;\n    border-radius: 8px;\n    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n}\n\n\n\n.ticket-detail-paragraph {\n    margin: 10px 0;\n    font-size: 1em;\n    line-height: 1.6;\n    color: #555;\n}\n\n.ticket-detail-status {\n    padding: 5px 10px;\n    border-radius: 4px;\n    font-size: 0.9em;\n    color: #fff;\n}\n\n.ticket-detail-status-open {\n    background-color: #007bff;\n}\n\n.ticket-detail-status-resolved {\n    background-color: #28a745;\n}\n\n.ticket-detail-status-pending {\n    background-color: #ffc107;\n}\n\n.ticket-detail-status-closed {\n    background-color: #6c757d;\n}\n\n.ticket-detail-replies-list {\n    list-style: none;\n    padding: 0;\n}\n\n \n\n\n\n\n.ticket-reply-form {\n    margin-top: 20px;\n}\n\n.ticket-reply-error {\n    color: #dc3545;\n    margin-bottom: 10px;\n}\n\n.ticket-reply-textarea {\n    width: 100%;\n    padding: 15px;\n    border: 1px solid #ddd;\n    border-radius: 6px;\n    font-size: 1em;\n    resize: vertical;\n    box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.1);\n    transition: border-color 0.2s ease;\n}\n\n.ticket-reply-textarea:focus {\n    border-color: #007bff;\n    outline: none;\n}\n\n.ticket-reply-button {\n    margin-top: 10px;\n    padding: 10px 20px;\n    background-color: #007bff;\n    color: white;\n    border: none;\n    border-radius: 4px;\n    font-size: 1em;\n    cursor: pointer;\n    transition: background-color 0.2s ease;\n}\n\n.ticket-reply-button:hover {\n    background-color: #0056b3;\n}\n\n.ticket-detail-loading {\n    text-align: center;\n    font-size: 1.2em;\n    color: #555;\n}\n.ticket-closed-container {\n    margin-top: 20px;\n    text-align: center;\n}\n.ticket-closed-message {\n    color: #ff0000;\n    font-weight: bold;\n}\n.ticket-reopen-button {\n    margin-top: 10px;\n    padding: 10px 20px;\n    font-size: 16px;\n    color: #fff;\n    background-color: #007bff;\n    border: none;\n    border-radius: 5px;\n    cursor: pointer;\n}\n.ticket-reopen-button:hover {\n    background-color: #0056b3;\n}\n\n\n.ticket-detail-replies-list {\n    list-style-type: none;\n    padding: 10px;\n    margin: 0;\n    display: flex;\n    flex-direction: column;\n    gap: 15px;\n    max-width: 95%;\n    margin: auto;\n}\n\n.ticket-detail-reply-item {\n    max-width: 75%;\n    padding: 15px 20px;\n    font-size: 16px;\n    position: relative;\n    word-wrap: break-word;\n    display: flex;\n    flex-direction: column;\n}\n\n.ticket-reply-user {\n    background-color: #32383f;  \n    color: white;\n    align-self: flex-end;\n    border-bottom-left-radius: 10px;\n    border-top-left-radius: 10px;\n    border-top-right-radius: 10px;\n}\n\n.ticket-reply-admin {\n    background-color: #a4b1d2;  \n    color: black;\n    align-self: flex-start;\n    border-bottom-right-radius: 10px;\n    border-top-right-radius: 10px;\n    border-top-left-radius: 10px;\n\n}\n\n.ticket-detail-reply-item p {\n    font-size: 18px;\n    margin: 5px 0;\n}\n\n.ticket-detail-reply-item small {\n    font-size: 14px;\n    margin-top: 5px;\n    opacity: 0.7;\n    align-self: flex-end;\n}\n\n.ticket-reply-user::after,\n.ticket-reply-admin::after {\n    content: \"\";\n    position: absolute;\n    bottom: 0;\n    width: 0;\n    height: 0;\n}\n\n.ticket-reply-user::after {\n    right: -10px;\n    border-left: 10px solid #222324;\n    border-top: 10px solid transparent;\n}\n\n.ticket-reply-admin::after {\n    left: -10px;\n    border-right: 10px solid #a4b1d2;\n    border-top: 10px solid transparent;\n}\n\n@media (max-width: 768px) {\n    .ticket-detail-reply-item {\n        max-width: 90%;\n        font-size: 14px;\n    }\n\n    .ticket-detail-reply-item p {\n        font-size: 16px;\n    }\n\n    .ticket-detail-reply-item small {\n        font-size: 12px;\n    }\n} */\n.ticket-detail-body {\n    font-family: Arial, sans-serif;\n    margin: 20px auto;\n    padding: 20px;\n    background-color: #f9f9f9;\n    border-radius: 8px;\n    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n}\n.ticket-detail-body {\n    margin-top: 20px;\n  }\n  \n  .ticket-detail-container {\n    background-color: #f9f9f9;\n    padding: 20px;\n    border: 1px solid #ddd;\n    border-radius: 5px;\n  }\n  \n  .ticket-detail-status {\n    font-weight: bold;\n  }\n  \n  .ticket-detail-status-open {\n    color: green;\n  }\n  \n  .ticket-detail-status-closed {\n    color: red;\n  }\n  \n  .ticket-reply-admin {\n    background-color: #e9f7e9;\n  }\n  \n  .ticket-reply-user {\n    background-color: #f1f1f1;\n  }\n  \n  .ticket-reply-form textarea {\n    resize: none;\n  }\n  \n  .ticket-reply-button {\n    margin-top: 10px;\n  }\n  \n\n\n  .ticket-detail-replies-list {\n    list-style: none;\n    padding: 0;\n  }\n  \n  .ticket-detail-reply-item {\n    background: #f9f9f9;\n    border: 1px solid #ddd;\n    border-radius: 5px;\n    padding: 10px 15px;\n    margin-bottom: 15px;\n    position: relative;\n  }\n  \n  .ticket-detail-reply-item.ticket-reply-admin {\n    background-color: #e6f7ff;\n  }\n  \n  .ticket-detail-reply-item.ticket-reply-user {\n    background-color: #fdfdfd;\n  }\n  \n  .ticket-detail-reply-item p {\n    margin: 0 0 5px;\n  }\n  \n  .ticket-detail-reply-item small {\n    display: block;\n    font-size: 12px;\n    color: #555;\n  }\n  \n  .ticket-reply-badge {\n    position: absolute;\n    top: -10px;\n    left: -10px;\n    background-color: #007bff;\n    color: white;\n    padding: 2px 8px;\n    border-radius: 3px;\n    font-size: 12px;\n  }\n  \n  .ticket-detail-timestamp {\n    text-align: right;\n    font-size: 12px;\n    color: #888;\n  }\n  \n  .ticket-reply-star-section {\n    text-align: right;\n    margin-top: 5px;\n  }\n  \n  .ticket-reply-star-section .stars {\n    display: inline-block;\n    color: #ffa500;\n  }\n  .body\n  {min-height: 100px;}\n\n  .ticket-reply-badge {\n    margin-left: 8px;\n    padding: 2px 8px;\n    font-size: 12px;\n    border-radius: 3px;\n    color: white;\n    font-weight: bold;\n  }\n  \n  .admin-badge {\n    background-color: #a6c8ff; /* Màu xanh dương nhạt cho Operator */\n  }\n  \n  .user-badge {\n    background-color: #32cd32; /* Màu xanh lá tươi cho Owner */\n  }\n  .ticket-reply-item {\n    display: flex;\n    flex-direction: column;\n    max-width: 70%;\n    padding: 10px;\n    background-color: #e6f7ff;\n    border-radius: 10px;\n    margin-bottom: 10px;\n    align-self: flex-end;\n    position: relative;\n}\n.ticket-reply-content {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n}\n\n  .ticket-reply-date {\n    font-size: 12px;\n    color: gray;\n    margin-left: auto;\n    text-align: right;\n    display: block;\n    /* display: flex; */\n}\n\n.ticket-detail-container {\n    max-width: 600px;\n    background-color: #f9f9f9;\n    border-radius: 12px;\n  }\n  \n  .card-title {\n    font-size: 22px;\n    font-weight: 600;\n  }\n  \n  .ticket-detail-paragraph {\n    font-size: 14px;\n  }\n  \n  .badge {\n    padding: 8px 12px;\n    font-size: 12px;\n    border-radius: 20px;\n  }\n  .ticket-detail-container {\n    max-width: 600px;\n    margin: 0 auto;\n  }\n  \n  .ticket-detail-content div {\n    border-bottom: 1px solid #ddd;\n    padding: 8px 0;\n  }\n  \n  .status-text {\n    font-size: 1rem;\n  }\n  \n/* customer button */\n  .custom-btn {\n    background-color: transparent;\n    color: white;\n    border: none;\n    padding: 10px 20px;\n    border-radius: 50px;\n    font-weight: bold;\n    cursor: pointer;\n    transition: all 0.3s ease-in-out;\n  }\n  \n  .custom-btn.btn-success {\n    background-color: #28a745;\n  }\n  \n  .custom-btn.btn-success:hover {\n    background-color: #218838;\n  }\n  \n  .custom-btn.btn-danger {\n    background-color: #dc3545;\n  }\n  \n  .custom-btn.btn-danger:hover {\n    background-color: #c82333;\n  }\n  .ck-editor__editable_inline {\n    min-height: 200px !important;\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
